import React, { CSSProperties } from 'react'
import './style.scss'

interface ISvgIconProps {
    icon: string,
    width?: string | number,
    height?: string | number,
    fill?: string,
    style?: CSSProperties,
    color?: string,
    className?: string,
    onClick?: React.MouseEventHandler<HTMLElement>,
    size?: number,
}

class SvgIcon extends React.Component<ISvgIconProps, any> {
    public handleClick = (event: any) => {
        const { onClick } = this.props
        if (onClick) {
            onClick(event)
        }
    }
    public render() {
        const { className, icon, color, size, style = {}, width, height } = this.props
        const styleObject: any = {}
        if (size) {
            styleObject['width'] = `${size}em`
            styleObject['height'] = `${size}em`
        }
        return (
            <svg
                className={`svg-icon ${className ? className : ''}`}
                onClick={this.handleClick}
                style={{ color, ...styleObject, ...style }}
                width={width}
                height={height}
            >
                <use xlinkHref={`#icon-${icon}`} />
            </svg>
        )
    }
}

export default SvgIcon
